// ============================================
// useSystemInfo Hook - System Information Data Fetching
// ============================================

import { useQuery } from '@tanstack/react-query';
import { api, type SystemInfo } from '@/lib/api';

export type { SystemInfo };

/**
 * Hook for fetching system information
 *
 * @param enabled - Whether the query should run
 * @returns Query result with system info data
 */
export function useSystemInfo(enabled = true) {
  return useQuery({
    queryKey: ['systemInfo'],
    queryFn: async () => {
      const response = await api.getSystemInfo();
      return response;
    },
    enabled,
    staleTime: 60 * 1000, // Consider data fresh for 60 seconds
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
  });
}
